import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IMessageTemplate } from '../../api/messageTemplates'
import { ReactComponent as CheckmarkCircle } from '../../assets/icons/checkmark-circle.svg'
import { ReactComponent as Close } from '../../assets/icons/close.svg'
import { ReactComponent as Earth } from '../../assets/icons/earth.svg'
import { ReactComponent as Pencil } from '../../assets/icons/pencil.svg'

import styles from './MessageTemplateContent.module.scss'

interface IMessageTemplateContentProps {
    messageTemplate: IMessageTemplate
    onSave: (messageTemplate: IMessageTemplate) => void
}

export const MessageTemplateContent = (props: IMessageTemplateContentProps) => {
    const { messageTemplate, onSave } = props
    const { t } = useTranslation()

    const messages = Object.entries(messageTemplate.messages).map(
        ([key, value]) => ({
            language: key,
            text: value,
        })
    )

    const handleSave = (language: string, newText: string) =>
        onSave({
            ...messageTemplate,
            messages: {
                ...messageTemplate.messages,
                [language]: newText,
            },
        })

    return (
        <div className={styles.messageTemplateContent}>
            <div className={styles.messageTemplateContent__header}>
                <h2>{t('templates')}</h2>
            </div>

            <div className={styles.messageTemplateContent__body}>
                <div className={styles.messageTemplateContent__messagesWrapper}>
                    {messages.map((msg) => (
                        <MessageBox
                            key={msg.language}
                            language={msg.language}
                            text={msg.text}
                            onSave={(newText) =>
                                handleSave(msg.language, newText)
                            }
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

interface IMessageBoxProps {
    language: string
    text: string
    onSave: (newText: string) => void
}

const MessageBox = (props: IMessageBoxProps) => {
    const { language, text, onSave } = props
    const [newText, setNewText] = useState<string>(text)

    const [isEditing, setIsEditing] = useState<boolean>(false)

    const handleSave = () => {
        onSave(newText)
        setIsEditing(false)
    }

    return (
        <div className={styles.messageBox}>
            <div className={styles.messageBox__textWrapper}>
                {isEditing ? (
                    <textarea
                        className={styles.messageBox__textArea}
                        value={newText}
                        onChange={(e) => setNewText(e.target.value)}
                    />
                ) : (
                    <div className={styles.messageBox__text}>{text}</div>
                )}
            </div>

            <div className={styles.messageBox__actions}>
                <div className={styles.languageBox}>
                    <Earth />
                    <span>{language}</span>
                </div>

                {isEditing ? (
                    <>
                        <button
                            className={styles.messageBox__actions__borderBtn}
                            onClick={handleSave}
                        >
                            <CheckmarkCircle />
                        </button>
                        <button
                            className={styles.messageBox__actions__borderBtn}
                            onClick={() => setIsEditing(false)}
                        >
                            <Close />
                        </button>
                    </>
                ) : (
                    <button
                        className={styles.messageBox__actions__borderBtn}
                        onClick={() => setIsEditing(true)}
                    >
                        <Pencil />
                    </button>
                )}
            </div>
        </div>
    )
}
